"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextPart = exports.Loading = exports.DetailItemReportRoot = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const DetailItemReportRoot = exports.DetailItemReportRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 10,
  background: theme.palette.common.white,
  boxSizing: 'border-box',
  padding: theme.spacing(3, 6),
  borderTop: `2px solid ${theme.palette.grey[100]}`,
  [theme.breakpoints.up('lg')]: {
    gridColumn: '1 / 2',
    gridRow: '1 / 2',
    width: '100%',
    height: '100%',
    padding: theme.spacing(4, 10),
    borderRadius: `${_constants.LARGE_COMPONENT_RADIUS} 0 0 ${_constants.LARGE_COMPONENT_RADIUS}`,
    overscrollBehavior: 'contain',
    overflowY: 'auto'
  }
}));
const TextPart = exports.TextPart = (0, _mui.styled)(_mui.Typography)(() => ({
  display: 'block'
}));
const Loading = exports.Loading = (0, _mui.styled)(_mui.CircularProgress)(({
  theme
}) => ({
  display: 'block',
  margin: theme.spacing(3, 'auto')
}));
